export function cloneJson(value) {
    return JSON.parse(JSON.stringify(value));
}
//# sourceMappingURL=json.js.map